<template>
    <o-form-group
        :id="this_id"
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <vue-editor
            v-if="!_is_readonly"
            :id="this_id"
            :class="input_class"
            v-bind="$attrs"
            :value="value"
            v-on="inputListeners"
        >
        </vue-editor>

        <span v-if="_is_readonly" v-html="value"></span>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin.js";
import OFormGroup from "../OFormGroup.vue";
import { VueEditor } from "vue2-editor";

export default {
    name: "OHtmlArea",
    components: { OFormGroup, VueEditor },
    mixins: [FormComponentMixin],
    methods: {
        on_change(event) {
            // No op
        },
        on_input(event) {
            if (event !== this.value) {
                // Only if Actually Changed value that we 'change'

                this.makeDirty();
                if (this.validator) {
                    this.validator.$touch();
                }

                this.changed = true;
                this.$emit("reset");
                this.$emit("input", event);
            }
        },
    },
};
</script>

<style scoped></style>
